import { render, staticRenderFns } from "./AltaPaciente.vue?vue&type=template&id=c47dd856"
import script from "./AltaPaciente.vue?vue&type=script&lang=js"
export * from "./AltaPaciente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports